import { useContext } from 'react';

import { VotingCardContext } from '../contexts/VotingCardContext';

export const useWidgetContext = () => {
  const context = useContext(VotingCardContext);

  if (!context) {
    throw new Error('useWidgetContext must be used within a VotingCardContextProvider');
  }

  return context;
};
